import getThemeImages from './getThemeImages';

const themeImages = getThemeImages();

export const imgBgSeriesLandscape = themeImages.bgSeriesLandscape;
export const imgBgSeriesPortrait = themeImages.bgSeriesPortrait;
export const imgBookSide = themeImages.bookSide;
export const imgBookWall = themeImages.bookWall;
export const imgHomeBgLandscape = themeImages.homeBgLandscape;
export const imgHomeBgPortrait = themeImages.homeBgPortrait;
export const imgLogoFacebook = themeImages.logoFacebook;
export const imgLogoInstagram = themeImages.logoInstagram;
export const imgLogoLinkedin = themeImages.logoLinkedin;
export const imgLogoLinktree = themeImages.logoLinktree;
export const imgLogoThreads = themeImages.logoThreads;
export const imgLogoTiktok = themeImages.logoTiktok;
export const imgLogoWattpad = themeImages.logoWattpad;
export const imgLogoWattpadFull = themeImages.logoWattpadFull;
export const imgLogoWebsite = themeImages.logoWebsite;
export const imgLogoX = themeImages.logoX;
export const imgNoCover = themeImages.noCover;
export const imgNoResult = themeImages.noResult;
export const imgPageNotFound = themeImages.pageNotFound;
export const imgSearchButton = themeImages.searchButton;
export const imgTigerEgg = themeImages.tigerEgg;
export const imgWoodenShelf = themeImages.woodenShelf;
